module.exports = __webpack_public_path__ + "img/ic-barcode.8d5233c9.svg";